import React, { useContext } from "react";

//Material UI stuff
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import TableCell from "@material-ui/core/TableCell";

//global state
import { StateContext } from "../../AppStateContext";

const ClusterRowInfoDelete = ({ setIsDeleteModalOpen }) => {
  //consume global state
  const state = useContext(StateContext);

  //when clicking the delete icon, the modal opens up
  //asking the user if they're sure to delete it
  const openModal = () => {
    setIsDeleteModalOpen(true);
  };

  return (
    <TableCell
      align="left"
      style={{
        borderBottom:
          state.theme === "dark" ? "1px solid #122742" : "1px solid #eaeaea",
      }}
    >
      <DeleteForeverIcon
        id="deleteClusterIcon"
        onClick={openModal}
        style={{
          color: state.theme === "dark" ? "#fff" : "#fa0171",
          cursor: "pointer",
          width: "30px",
        }}
      />
    </TableCell>
  );
};

export default ClusterRowInfoDelete;
